<template>
  <div>

    <!-- PROMPTS -->
    <!-- new brand -->
    <addNewMistake
    :ItemToModify="ItemToModify"
    :isPromptActive="IsPromptActive.newMistake"
    @addedNewMistake="allMistakes.unshift($event);"
    @closePrompt="IsPromptActive.newMistake = false"
    @deleteItemFromList="deleteItemFromList($event)"
    />
    <!-- columns -->
    <columns-manager
      :isPromptActive="IsPromptActive.columnsManager"
      :HideableColumns="Columns"
      :isHidden="isHidden"
      @updatePromptColumns="isHidden = $event;"
      @closePromptColumns="IsPromptActive.columnsManager = false;"
    />
    <!-- END PROMPTS -->

    <template>
      <vs-table ref="table" :data="allMistakes" pagination :max-items="itemsPerPage" noDataText="No hay errores" search>
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between" style="padding-bottom: 14px;">
          <div class="flex flex-wrap-reverse items-center">
            <vs-button color="primary" type="filled" class="columnsManagerBtn" @click="manageColumns()">
              <font-awesome-icon icon="columns"/>
            </vs-button>
            <vs-button class="ml-2" color="primary" type="border" @click="openPrompt()">
              <font-awesome-icon icon="plus"/>
              Nuevo error
            </vs-button>
          </div>

          <!-- <items-per-page :itemsLength="allMistakes.length" :currentPage ="currentPage" :itemsPerPage ="itemsPerPage"/> -->
        </div> <!-- header -->


        <template slot="thead">
          <vs-th v-for="Col in Columns" v-if="!isHidden[Col.name]" :class="Col.nowrap == false ? '' : 'nowrap'">
            {{ Col.title }}
          </vs-th>
        </template>



        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- id -->
            <vs-td v-if="!isHidden.id" class="centered"><vs-chip color="primary">{{ tr.id }}</vs-chip></vs-td>
            <!-- date -->
            <vs-td v-if="!isHidden.dateTime" style="width: 78px;">
              <vx-tooltip :text="getTimeOfDB(tr.dateTime)">
                {{ getDateOfDB(tr.dateTime) }}
              </vx-tooltip>
            </vs-td>
            <!-- date -->
            <vs-td v-if="!isHidden.saleDate" style="width: 78px;">
              <vx-tooltip :text="getTimeOfDB(tr.saleDate)">
                {{ getDateOfDB(tr.saleDate) }}
              </vx-tooltip>
            </vs-td>
            <!-- modify -->
            <vs-td v-if="!isHidden.edit" class="centered autoWidth">
              <vs-button type="border" @click="openPrompt(tr, 'edit')">
                <font-awesome-icon icon="edit"/>
              </vs-button>
            </vs-td>
            <!-- saleID -->
            <vs-td v-if="!isHidden.saleID" class="centered"><vs-chip color="primary">{{ tr.saleID }}</vs-chip></vs-td>
            <!-- state -->
            <vs-td v-if="!isHidden.state" class="nowrap">
              <div class="state" :class="'state'+tr.stateID" @click="changeState(tr)">
                {{ tr.state }}
              </div>
            </vs-td>
            <!-- buyerFullName -->
            <vs-td v-if="!isHidden.buyerFullName">{{ tr.buyerFullName }}</vs-td>
            <!-- stateID -->
            <vs-td v-if="!isHidden.stateID" class="centered"><vs-chip color="primary">{{ tr.stateID }}</vs-chip></vs-td>
            <!-- responsibleEmployeeID -->
            <vs-td v-if="!isHidden.responsibleEmployeeID" class="centered"><vs-chip color="primary">{{ tr.responsibleEmployeeID }}</vs-chip></vs-td>
            <!-- responsibleEmployee -->
            <vs-td v-if="!isHidden.responsibleEmployee" style="position: relative;">
              <div class="userImg">
                <img :src="getImg(`images/employees/${tr.responsibleEmployeeID}.png`)">
              </div>
              <span style="padding-left: 40px;">{{ tr.responsibleEmployee }}</span>
            </vs-td>
            <!-- responsibleEmployee -->
            <vs-td v-if="!isHidden.description">{{ tr.description }}</vs-td>
            <!-- delete -->
            <vs-td v-if="!isHidden.delete" class="centered autoWidth">
              <vs-button type="border" color="danger" @click="deleteItem(tr)">
                <font-awesome-icon icon="trash"/>
              </vs-button>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </template> <!-- table -->

  </div>
</template>










<script>
// mixins
import { vsTableConfig } from '@/mixins/vsTableConfig.js';
export default {
  mixins: [vsTableConfig],
  components: {
    addNewMistake: () => import('./components/mistakes/AddNewMistake.vue'),
  },
  data() {
    return {
      IsPromptActive: { newMistake: false, },
      allMistakes: [],
      ItemToModify: null,
      // static
      Columns: [
        { name: 'id'    , title: 'ID', },
        { name: 'dateTime'  , title: 'Fecha de registro', nowrap: false },
        { name: 'saleDate'  , title: 'Fecha de compra',   nowrap: false },
        { name: 'edit', title: 'Editar', },
        { name: 'stateID', title: 'ID de estado', },
        { name: 'state', title: 'Estado', },
        { name: 'saleID', title: 'ID de venta', },
        { name: 'buyerFullName', title: 'Comprador', },
        { name: 'responsibleEmployeeID', title: 'ID Responsable', },
        { name: 'responsibleEmployee', title: 'Responsable', },
        { name: 'description', title: 'Descripción', },
        { name: 'delete', title: 'Eliminar', },
      ],
      selectedProfile: 1, // Lautaro
      Profiles: [
        /* 00 - Lisandro */ [],
        /* 01 - Lautaro */ [ 'id', 'dateTime', 'saleID', 'stateID', 'responsibleEmployeeID', ],
      ],
    };
  },
  computed: {
    filteredMistakes: function() {
      return this.allMistakes;
    },
  },
  created() {
    this.loadMistakes();
  },
  methods: {
    // changeState
    // deleteItem
    // deleteItemFromList
    // loadMistakes
    // openPrompt
    changeState(Mistake) {
      let allStates = this.dataDB.SalesMistakesStates;
      let allStateIDs = this.dataDB.SalesMistakesStateIDs;
      let newVal = allStates.length <= Mistake.stateID+1 ? 1 : Mistake.stateID+1;
      let Params = {
        mistakeID: Mistake.id,
        stateID: newVal,
      }
      Mistake.stateID = newVal;
      Mistake.state = allStates[newVal];
      this.modifyMistakeDB(Params);
    },
    deleteItem(Item) {
      this.deleteItemFromList(Item.id);
      let Params = {
        mistakeID: Item.id,
        isActive: 0,
      }
      this.modifyMistakeDB(Params);
    },
    deleteItemFromList(itemID) {
      let index = this.allMistakes.findIndex(i => i.id == itemID);
      this.allMistakes.splice(index, 1);
    },
    modifyMistakeDB(Params) {
      const vm = this;
      this.conectToDB({
        file: 'SaleMistakes', action: 'modifyMistake', params: Params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
        },
      });
    },
    loadMistakes() {
      let Params = {
        isActive: 1,
      }
      const vm = this;
      this.conectToDB({
        file: 'SaleMistakes', action: 'getMistake', params: Params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.allMistakes = res.data.data;
          console.log(res.data.data);
        },
      });
    },
    openPrompt(Item, action = 'create') {
      switch (action) {
        case 'create':
          this.ItemToModify = null;
          break;
        case 'edit':
          this.ItemToModify = Item;
          break;
      }
      this.IsPromptActive.newMistake = true;
    },
  }, // METHODS
} // export default

</script>

<style lang="scss">
.state {
  border-radius: 30px;
  padding: 5px 10px;
  border: 1px solid;
  width: 100%;
  text-align: center;
}
.state1 { background-color: #7FDBFF; color: #004966; border-color: #004966; }
.state2 { background-color: #FF851B; color: #663000; border-color: #663000; }
.state3 { background-color: #2ECC40; color: #0E3E14; border-color: #0E3E14; }

.userImg {
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 1px solid;
  border-radius: 30px;
  position: absolute;
  left: 2px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
